import type { OrganizationPlannerJobDetailsLocales } from '../types';

const organizationPlannerJobDetailsLocales: OrganizationPlannerJobDetailsLocales =
  {
    assignmentDetails: 'Opdracht details',
    assignments: 'Opdrachten',
    assignmentType: 'Opdracht type',
    basis: 'Basis',
    cancelOrder: 'Annuleer opdracht',
    changeOrder: 'Wijzig opdracht',
    comments: 'Opmerkingen',
    competencies: 'Competenties',
    dashboard: 'Dashboard',
    date: 'Datum',
    documents: 'Documenten',
    download: 'Download',
    downloadInvoice: 'Download factuur',
    favoriteFreelancer: 'Favoriet freelancer',
    freelancer: 'Freelancer',
    hours: 'Uren',
    hoursCheckedBy: 'Uren gecheckt door',
    interestedUsers: 'Geïnteresseerde freelancers',
    invitedUsers: 'Uitgenodigde freelancers',
    invoice: 'Factuur',
    invoiceDate: 'Factuurdatum',
    invoices: 'Facturen',
    kvkNumber: 'KvK-nummer',
    location: 'Locatie',
    login: 'Inloggen',
    logout: 'Logout',
    madeBy: 'Aangemaakt door',
    noDocumentExist: 'Er zijn geen documenten',
    noUserHaveBeenInvited: 'Er zijn geen freelancers uitgenodigd.',
    noUserHaveShownInterest:
      'Er hebben nog geen freelancers interesse getoond.',
    options: 'Opties',
    orderCreated: 'Opdracht aangemaakt',
    pause: 'Pauze',
    perHourVAT: '€%{count} per uur (excl btw)',
    phoneNumber: 'Telefoon',
    review: {
      one: '%{count} beoordeling',
      other: '%{count} beoordelingen',
      zero: 'Nog geen beoordeling',
    },
    settings: 'Instellingen',
    status: 'Status',
    time: 'Tijd',
    totalAmountTaxExcluded: 'Totaalbedrag (excl. btw)',
    unfavoriteFreelancer: 'Ontfavoriet freelancer',
    viewProfile: 'Bekijk profiel',
  };

export default organizationPlannerJobDetailsLocales;
